import {
  makeStyles, tokens, Text, Badge,
  Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell,
} from '@fluentui/react-components';
import { Page, PageHeader, Card, Loading, ErrorState } from '../components/common';
import { PILLARS } from '../theme/pillars';
import { useCustomer } from '../context/CustomerContext';

const useStyles = makeStyles({
  tableWrap: { width: '100%', overflowX: 'auto', minWidth: 0 },
  muted: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase200 },
  section: { display: 'flex', flexDirection: 'column', rowGap: tokens.spacingVerticalS },
});

/**
 * What the tool is able to check, independent of any customer.
 *
 * This used to be the pillar pages, which was the wrong home: it made every
 * customer's Identity page identical. It belongs here, as reference material.
 */
export function Catalogue() {
  const styles = useStyles();
  const { primitives, loading, error } = useCustomer();

  if (loading) return <Loading />;
  if (error) return <ErrorState error={error} />;

  return (
    <Page>
      <PageHeader
        title="Control catalogue"
        description="Every control outcome this assessment can measure, independent of any customer."
      />

      {PILLARS.map((pillar) => {
        const rows = primitives.filter((p) => p.msPillar === pillar.id);
        if (rows.length === 0) return null;
        return (
          <Card key={pillar.id}>
            <div className={styles.section}>
              <Text weight="semibold" size={400}>{pillar.label}</Text>
              <Text className={styles.muted}>{pillar.description}</Text>
              <div className={styles.tableWrap}>
              <Table size="small" aria-label={`${pillar.label} control outcomes`}>
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell>Control outcome</TableHeaderCell>
                    <TableHeaderCell>CISA pillar</TableHeaderCell>
                    <TableHeaderCell>Framework mappings</TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {rows.map((p) => (
                    <TableRow key={p.primitiveId}>
                      <TableCell>
                        <Text weight="semibold" size={200}>{p.title}</Text>
                        <div className={styles.muted}>{p.statement}</div>
                      </TableCell>
                      <TableCell>
                        {/* Held separately from the Microsoft pillar because
                            the two models do not align one to one. */}
                        <span className={styles.muted}>{p.cisaPillar ?? 'Not mapped'}</span>
                      </TableCell>
                      <TableCell>
                        <Badge appearance="tint"
                               color={p.mappingCount > 0 ? 'informative' : 'danger'}>
                          {p.mappingCount}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              </div>
            </div>
          </Card>
        );
      })}
    </Page>
  );
}
